import React from 'react'
import './Loading.css'

import {
    Row,
    Col,
  } from "reactstrap";

function Loading ({message="Loading"}){
    return (
        <div class="loader-wrapper">
            <span class="logo-dot">
            
            <svg width="108px" height="128px" viewBox="0 0 54 64">
            <path
                className="beat-loader"
                d="M.5 38.5H16l3-13 5.5 32 7-50 6 39 5.5-8h10.5"
                strokeWidth={2}
                stroke="none"
                fill="none"
                fillRule="evenodd"
            />
            </svg>
            <Row style={{position:'fixed',top:'64%',left:'55%',marginTop: '-50px',marginLeft:'-100px'}}> 
  

                
               
                    <h4 style={{color:'rgb(140,140,140)'}}></h4>
               
                
            </Row>
            </span>
        </div>
    )
}
export default Loading